module.exports = __webpack_public_path__ + "img/env.8178637.png";